import { TextareaAutosize } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Textarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  borderColor: theme.palette.text.secondary,
  borderWidth: 1,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
  fontFamily: 'Poppins',
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  fontWeight: 500,
  outline: 'none',
  '&::placeholder': {
    fontSize: '0.875rem',
  },
  '&:focus': {
    border: `1px solid ${theme.palette.secondary[500]}`,
  },
}));
